export default __webpack_public_path__ + "static/media/EmAnaliseOTW.d5eafee7.svg";